<template lang="pug">
v-container
  a.event-title(@click="gohome") Events
  router-view.mt-3
</template>

<script>
export default {
  computed: {
    isHome() {
      return this.$route.path == "/event";
    },
  },
  methods: {
    gohome() {
      if (this.isHome) return;
      this.$router.push("/event");
    },
  },
};
</script>

<style lang="sass" scoped>
.event-title
  font-size: 28px
</style>